export default class CoreoSortableDirective {
    constructor() {
        this.restrict = 'A';
        this.require = '?ngModel';
    }
    link(scope, element, attributes, ngModel) {
    }
}
